export const RECETAS_EVENT_OPTIONS = [
  { value: '', label: 'Todos los eventos' },
  { value: 'pedido_creado', label: 'Pedido creado' },
  { value: 'pedido_creado_alta_rapida', label: 'Alta rápida' },
  { value: 'pedido_creado_conversacion', label: 'Desde conversación' },
  { value: 'pedido_derivado', label: 'Asignación a médico' },
  { value: 'pedido_asignado_emision', label: 'Asignación a emisión' },
  { value: 'pedido_aprobado', label: 'Aprobación' },
  { value: 'pedido_rechazado', label: 'Rechazo' },
  { value: 'receta_emitida', label: 'Emisión de receta' }
];

export function recetaEventLabel(eventType) {
  const e = String(eventType || '').trim();
  if (e === 'pedido_creado') return 'Pedido creado';
  if (e === 'pedido_creado_alta_rapida') return 'Alta rápida';
  if (e === 'pedido_creado_conversacion') return 'Ingreso desde conversación';
  if (e === 'pedido_derivado') return 'Asignado a médico';
  if (e === 'pedido_asignado_emision') return 'Asignado a emisión';
  if (e === 'pedido_aprobado') return 'Tratamiento aprobado';
  if (e === 'pedido_rechazado') return 'Tratamiento rechazado';
  if (e === 'receta_emitida') return 'Receta emitida';
  return e || 'Evento';
}

export function recetaEventIcon(eventType) {
  const e = String(eventType || '').trim();
  if (e === 'pedido_creado' || e === 'pedido_creado_alta_rapida' || e === 'pedido_creado_conversacion') return '✨';
  if (e === 'pedido_derivado') return '📋';
  if (e === 'pedido_aprobado') return '✅';
  if (e === 'pedido_rechazado') return '⛔';
  if (e === 'receta_emitida') return '📄';
  return '◆';
}

export function recetaEventTone(eventType) {
  const e = String(eventType || '').trim();
  if (e === 'pedido_aprobado' || e === 'receta_emitida') return 'success';
  if (e === 'pedido_rechazado') return 'danger';
  if (e === 'pedido_derivado' || e === 'pedido_asignado_emision') return 'assign';
  if (e.includes('creado')) return 'create';
  return 'neutral';
}

export function pedidoEstadoLabel(estado) {
  const e = String(estado || '').toLowerCase();
  if (e === 'pendiente_derivacion') return 'Pendiente derivación';
  if (e === 'pendiente_aprobacion_medica') return 'Pendiente médico';
  if (e === 'aprobado') return 'Aprobado';
  if (e === 'rechazado') return 'Rechazado';
  if (e === 'cancelado') return 'Cancelado';
  if (e === 'pedido_generado_farmacia') return 'En farmacia';
  return estado || '—';
}

export function actorRoleHint(event) {
  if (!event) return '';
  if (event.actor_administrativo_id || event.target_administrativo_id) return 'Administrativo';
  if (event.actor_medico_id || event.target_medico_id) return 'Médico';
  if (event.event_type === 'pedido_creado_conversacion') return 'Operador';
  return 'Usuario';
}

export function resolveEventActorName(event) {
  return (
    String(event?.actor_display_name || '').trim()
    || String(event?.actor_username || '').trim()
    || 'Sistema'
  );
}

function parseEventMetadata(metadata) {
  if (!metadata) return {};
  if (typeof metadata === 'object' && !Array.isArray(metadata)) return metadata;
  try {
    return JSON.parse(String(metadata)) || {};
  } catch (_) {
    return {};
  }
}

export function resolveEventTargetLabels(event) {
  const type = String(event?.event_type || '').trim();
  const meta = parseEventMetadata(event?.metadata);
  const emisor = String(meta?.emisor_tratamiento || event?.emisor_tratamiento || '').toLowerCase();
  const labels = [];

  if (type === 'pedido_asignado_emision') {
    if (event?.target_administrativo_nombre) {
      labels.push(`Administrativo emisor: ${event.target_administrativo_nombre}`);
    } else if (event?.target_administrativo_id) {
      labels.push(`Administrativo emisor #${event.target_administrativo_id}`);
    }
    return labels;
  }

  if (type === 'pedido_derivado') {
    if (event?.target_medico_nombre) labels.push(`Médico: ${event.target_medico_nombre}`);
    else if (event?.target_medico_id) labels.push(`Médico #${event.target_medico_id}`);
    if (event?.target_administrativo_nombre) labels.push(`Derivado por: ${event.target_administrativo_nombre}`);
    else if (event?.target_administrativo_id) labels.push(`Administrativo #${event.target_administrativo_id}`);
    return labels;
  }

  if (type === 'pedido_aprobado' && emisor === 'administrativo') {
    if (event?.target_medico_nombre) labels.push(`Médico tratante: ${event.target_medico_nombre}`);
    else if (event?.target_medico_id) labels.push(`Médico tratante #${event.target_medico_id}`);
    return labels;
  }

  if (event?.target_medico_nombre) labels.push(`Médico: ${event.target_medico_nombre}`);
  else if (event?.target_medico_id) labels.push(`Médico #${event.target_medico_id}`);

  if (event?.target_administrativo_nombre) labels.push(`Administrativo: ${event.target_administrativo_nombre}`);
  else if (event?.target_administrativo_id) labels.push(`Administrativo #${event.target_administrativo_id}`);

  if (!labels.length && event?.numero_receta) labels.push(`Receta ${event.numero_receta}`);
  return labels;
}

export function resolveEventTargetLabel(event) {
  return resolveEventTargetLabels(event).join(' · ');
}
